<template>
  <card :has-settings="false" :has-subtitle="false" auto-height title="On Screen Message">
    <template #headerUtils v-if="$can('Edit', 'PatientMonitor') && monitor">
      <button class="button is-outlined is-primary" :class="{'is-focused': editMode}" @click="editMode = true">Edit</button>
    </template>
    <template #content>
      <div v-if="editMode">
        <input-with-validation field-label="" b-name="input" v-model="awayMessage" placeholder="Write on screen message" :rules="{ max: 48 }" maxlength="48"></input-with-validation>
        <div class="is-flex is-justify-content-center">
          <button class="button is-white" @click="cancel">Cancel</button>
          <button class="button is-danger mr-2" @click="clear">Clear</button>
          <button class="button is-primary" @click="saveButtonAction">Save</button>
        </div>
      </div>
      <div v-else>
        <p class="away-message">{{ awayMessage || 'No Message Set' }}</p>
      </div>
    </template>
  </card>
</template>

<script>
import Card from "@/components/card/Card.vue";
import InputWithValidation from "@/components/validation/InputWithValidation.vue";
import to from "@/lib/to";
import {EventBus, EVENTS} from "@/lib/EventBus";

export default {
  name: "AwayMessageEditCard",
  components: {InputWithValidation, Card},
  props: {
    monitor: {
      type: Object
    }
  },
  watch: {
    monitor: {
      handler(newVal) {
        if (newVal) {
          this.awayMessage = this.originalAwayMessage = this.monitor.away_message || ''
        }
      },
      immediate: true
    },
  },
  methods: {
    async saveButtonAction() {
      await this.save(this.awayMessage)
    },
    async clear() {
      await this.save('')
    },
    async save(message) {
      const [err] = await to(this.$http.post(`/patient_monitors/${this.monitor.id}/away_message`, { message: message }))
      if (!err) {
        this.originalAwayMessage = message = (message || '').trim()
        if (!message) {
          this.awayMessage = ''
        }
        if (this.monitorId) {
          EventBus.$emit(EVENTS.RELOAD_WIDGET_MONITOR_DATA, this.monitorId)
        }
        this.$buefy.toast.open({
          message: `On screen message ${message ? 'saved' : 'cleared'} successfully`,
          type: 'is-success'
        });
        this.editMode = false
      }
    },
    cancel() {
      this.awayMessage = this.originalAwayMessage
      this.editMode = false
    }
  },
  data() {
    return {
      editMode: false,
      originalAwayMessage: '',
      awayMessage: ''
    }
  }
}
</script>

<style scoped lang="scss">
.away-message {
  font-size: 14px;
  line-height: 18px;
}
</style>